/**
 * 결제 수단 조합 카탈로그 API (#217/#218, β-1b).
 *
 * BE 공개 엔드포인트 `GET /api/v1/payment-method-combinations` 호출.
 * β-1b 단계에서는 함수 선언만. 소비는 β-2b (CheckoutPage) 에서 시작.
 *
 * 외부 리뷰 P1-1 (fail-closed): 응답 형태 검증 실패 시 throw → 훅 error 상태 →
 * 소비처에서 스펙 §3.4 fail-closed 분기 진입.
 */
import { apiClient } from './client';
import type { PaymentMethodCombination } from './types';

export const paymentMethodsApi = {
  async getCombinations(): Promise<PaymentMethodCombination[]> {
    const res = await apiClient.get<{ data: PaymentMethodCombination[] }>(
      '/api/v1/payment-method-combinations'
    );

    if (!res || !Array.isArray(res.data)) {
      throw new Error('Invalid payment method combinations response');
    }

    return res.data;
  },
};
